module.exports = __webpack_public_path__ + "static/media/schedule-positive.6aac51fb.svg";